import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { createTheme, TextField, withStyles } from '@material-ui/core';
import { ThemeProvider } from "@material-ui/styles";
import styled from 'styled-components';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomChip from '../../shared/CustomChip';

const CssTextField = withStyles({
  root: {
    width: '100%',
    '& .MuiInput-underline::before': {
      borderBottom: '1px solid #dcdcdc',
    },
    '& .MuiInput-underline::after': {
      borderBottom: '2px solid #9240C9',
    },
    "&:hover": {
    },
    "&$focused": {
      borderColor: "#9240C9"
    }
  },
  focused: {}
})(TextField);

const defaultMaterialTheme = createTheme({
  palette: {
    primary: { 500: '#9240C9' },
  },
});

const Label = styled.label`
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.05em;
  color: #ff6868;
  display: block;
  margin-bottom: ${({ chipsActive }) => chipsActive ? '0' : '1.5em'};
`

const OptionImg = styled.img`
  height: 1.5em;
  width: auto;
  margin-right: .5em;
`

const useStyles2 = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '.25em'
  },
  chip: {
    margin: 2,
  },
}));


const useInputStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '&::before': {
      borderBottom: '1px solid #dcdcdc',
    },
    '&::after': {
      borderBottom: '2px solid #9240C9',
    },
    "&:hover": {
    },
    "&$focused": {
      borderColor: "#9240C9"
    }
  }
}));

export const CustomizeSelect = ({ name, value, label, handleChange, options, disabled, multiple, countSelected, checkbox }) => {
  const classes2 = useStyles2();
  const inputClasses = useInputStyles();
  const [focused, setFocused] = useState(false);

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      {label &&
        <Label
        // chipsActive={((multiple && !countSelected) && (value.length > 0 && value.length !== options.length)) && true}
        >
          {label}
        </Label>
      }
      <Autocomplete
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        name={name}
        multiple={multiple}
        options={options}
        onChange={handleChange}
        disableCloseOnSelect
        disabled={disabled}
        autoComplete={true}
        getOptionLabel={(option) => option.label}
        noOptionsText='No hay opciones disponibles'
        limitTags={1}
        getOptionSelected={(option, { multiple, value }) => {
          if (!multiple) {
            /*
                * PROPOSAL for single selection, be able to provide own logic.
              */
            return (option.value === value);
          }
          return false;
        }}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            {console.log(selected)}
            <Checkbox
              style={{ marginRight: 8 }}
              checked={selected}
              color='primary'
            />
            {option.img && <OptionImg src={option.img} />}
            <span style={{ fontFamily: selected ? 'OpenSansBold' : 'OpenSansRegular' }}>{option.label}</span>
          </React.Fragment>
        )}
        renderTags={(value, getTagProps) =>
          value.length === options.length
            ? <span style={{ marginBottom: '.5em' }}>Todos</span>
            : <div className={classes2.chips}>
              {
                countSelected
                  ? <span>{`${value.length} seleccionados`} {focused ? ',' : ''}</span>
                  : value.map((option, index) => (
                    <CustomChip variant="outlined" label={option.label} img={option.img} {...getTagProps({ index })} />
                  ))
              }
            </div>
        }
        value={value}
        renderInput={(params) => (
          <>
            <CssTextField {...params} placeholder="" style={{ inputClasses }} />
          </>
        )}
      />
    </ThemeProvider>
  )
}

CustomizeSelect.propTypes = {
  options: PropTypes.array
}

export default CustomizeSelect
